import React from 'react';

import { GolfHeaderContainer } from '../organisms/golfHeaderContainer';
import SavedSearchCriteriaContainer from "../organisms/savedSearchCriteriaContainer";
import { PlayDateContainer } from '../organisms/playDateContainer';
import StartTimeContainer from "../organisms/startTimeContainer";
import GolfSearchContainer from '../organisms/golfSearchContainer';
import { GolfSearchFooterContainer } from '../organisms/golfSearchFooterContainer';
import  GolfLoginCheck from '../../util/golfLoginCheck';
import GolfReservationPopupContainer from '../organisms/golfReservationPopupContainer';
import AreaAndFacilitySelectionContainer from '../organisms/areaAndFacilitySelectionContainer'
import GolfFacilityCalendarContainer from '../organisms/golfFacilityCalendarContainer';

class GolfSearchTemplate extends React.Component {

    render() {
        return (
            <>
                <GolfLoginCheck />
                <GolfHeaderContainer 
                    categoryLabel1={"ゴルフ予約"} 
                    categoryLabel2={"GOLF"}
                    path={"/reserve/top"}
                    onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}/>
                <SavedSearchCriteriaContainer 
                    state={this.props.state.savedSearchCriteriaPopup}
                    onClickOpenSavedSearchCriteriaWindow={this.props.onClickOpenSavedSearchCriteriaWindow} />
                <PlayDateContainer 
                    state={this.props.state.playDatePopup} 
                    onClickOpenSelectDateWindow={this.props.onClickOpenSelectDateWindow}   
                    playDateFlg={this.props.state.playDateFlg} />
                <StartTimeContainer 
                    state={this.props.state.startTimePopup}
                    onClickOpenStartTimeWindow={this.props.onClickOpenStartTimeWindow} />
                <AreaAndFacilitySelectionContainer 
                    state={this.props.state.areaSelectionPopup} 
                    onClickOpenSelectAreaWindow={this.props.onClickOpenSelectAreaWindow} />
                <GolfSearchContainer 
                    onClickOpenSavedSearchCriteriaWindow={this.props.onClickOpenSavedSearchCriteriaWindow}
                    onClickOpenSelectDateWindow={this.props.onClickOpenSelectDateWindow} 
                    onClickOpenStartTimeWindow={this.props.onClickOpenStartTimeWindow}
                    onClickOpenSelectAreaWindow={this.props.onClickOpenSelectAreaWindow}
                    onClickOpenFacilityCalendarWindow={this.props.onClickOpenFacilityCalendarWindow} />             
                <GolfSearchFooterContainer/>
                <GolfReservationPopupContainer
                    state={this.props.state}
                    onClickClosePopupWindow={this.props.onClickClosePopupWindow}
                />
                <GolfFacilityCalendarContainer
                    state={this.props.state}
                    facilityCalendarFlg={this.props.state.facilityCalendarFlg}
                    onClickCalendarMove={this.props.onClickCalendarMove}
                    onClickCloseFacilityCalendarWindow={this.props.onClickCloseFacilityCalendarWindow}
                />
            </>
        )
    }
}
export default GolfSearchTemplate;